import { initialUserState } from './UserReducer'
import { UserState } from './UserState'
import { UserType } from './UserType'

export function initUserFacebook(userId: string, dataMix: { [key: string]: string }) {
  const data: UserState = initialUserState
  data.id = userId
  data.lastModified = Math.floor(Date.now() / 1000)
  data.birthday = dataMix.birthday
  data.displayname = dataMix.name
  data.firstname = dataMix.first_name
  data.lastname = dataMix.last_name
  data.email = dataMix.email

  return data
}

export function initUserGoogle(userId: string, userdata: { [key: string]: string }) {
  const data: UserState = initialUserState
  data.id = userId
  data.lastModified = Math.floor(Date.now() / 1000)
  data.firstname = userdata.givenName
  data.lastname = userdata.familyName
  data.email = userdata.email
  data.displayname = userdata.name
  return data
}

export function initManualUser(data: UserState) {
  const data2: UserState = { ...initialUserState, ...data, displayname: data.email }

  data2.lastModified = Math.floor(Date.now() / 1000)
  return data2
}

export const updateUserAction = (profile: Partial<UserState>) => {
  return {
    type: UserType.UPDATE_USER,
    payload: { value: profile }
  }
}

export const signCGUAction = (cguVersionSigned: number, cguVersionSignedDate: number) => {
  return {
    type: UserType.SIGN_CGU,
    payload: { cguVersionSigned, cguVersionSignedDate }
  }
}

export const definseStripeId = (stripeCustomerId: string) => {
  return { type: UserType.DEFINE_STRIPEID, payload: { stripeCustomerId } }
}

export const signOut = () => {
  return { type: UserType.LOGOUT }
}

// export function logout() {
//   return (dispatch, getState) => {
//     if (getState().UserReducer.id != null) {
//       database.ref(`users/${getState().UserReducer.id}/backup`).keepSynced(false)
//       database.ref(`users/${getState().UserReducer.id}/backupProjects`).keepSynced(false)
//       database.ref(`users/${getState().UserReducer.id}/mailProfile`).keepSynced(false)
//     }

//     dispatch({ type: types.LOGOUT })
//   }
//   //unsync
// }

// export function defineFirstName(firstname: string): Action {
//   return {
//     type: types.DEFINE_FIRSTNAME,
//     firstname
//   }
// }

// export function defineLastName(lastname: string): Action {
//   return {
//     type: types.DEFINE_LASTNAME,
//     lastname
//   }
// }

// export function defineMail(email: string): Action {
//   return {
//     type: types.DEFINE_MAIL,
//     email
//   }
// }

// export function updateLastModified() {
//   return dispatch => {
//     let value = {
//       lastModified: Math.floor(Date.now() / 1000)
//     }
//     dispatch(updateSaveUser(value))
//   }
// }

// export function decreaseFreeToken() {
//   return (dispatch, getState) => {
//     let value = {
//       freeToken().UserReducer.freeToken - 1 >= 0 ? getState().UserReducer.freeToken - 1 : 0
//     }
//     dispatch(updateSaveUser(value))
//   }
// }

// export function increaseFreeToken(reward: number) {
//   return (dispatch, getState) => {
//     let value = {
//       freeToken().UserReducer.freeToken + reward,
//       tokenGainThisMonth().UserReducer.tokenGainThisMonth + reward
//     }
//     dispatch(updateSaveUser(value))
//   }
// }

// export function resetFreeToken(token: number, date: number) {
//   return dispatch => {
//     let value = {
//       freeToken: token,
//       tokenGainThisMonth: 0,
//       resetTokenDate: date
//     }
//     dispatch(updateSaveUser(value))
//   }
// }

// export function resetUser() {
//   return {
//     type: types.RESET_USER
//   }
// }

// export function deleteBackup(item: Object, onComplete: any) {
//   return (dispatch, getState) => {
//     let dateChange = Math.floor(Date.now() / 1000)
//     database.ref(`users/${getState().UserReducer.id}/backup/${item.key_backup}`).remove(() => {
//       database
//         .ref(`users/${getState().UserReducer.id}/backup/${item.key_backup}`)
//         .update({
//           deleted: 1,
//           saveDate: dateChange,
//           name: item.name
//         })
//         .then(() => {
//           onComplete()
//         })
//     })
//     dispatch(updateLastBackup(dateChange))
//   }
// }

// export function updateCGU(version: number) {
//   return dispatch => {
//     let value = {
//       cguVersionSigned: version,
//       cguVersionSignedDate: moment().format('x')
//     }
//     dispatch(updateSaveUser(value))
//   }
// }

// export function defineDateMailTrial() {
//   return dispatch => {
//     const dateL = moment()
//       .add(1, 'month')
//       .format('x')
//     let value = {
//       customMailTrialLimit: dateL,
//       lastModified: Math.floor(Date.now() / 1000)
//     }
//     dispatch(updateSaveUser(value))
//   }
// }
